module.exports = {
  DataError: require('./DataError'),
  NotSupportedError: require('./NotSupportedError')
}
